import { render } from "./AutoMatricula.vue?vue&type=template&id=78dc4cd0"
import script from "./AutoMatricula.vue?vue&type=script&lang=js"
export * from "./AutoMatricula.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__